import { IEquipment } from '@/pages/Equipment/equipment.types'
import Tag from '@/shared/Tags/Tag'

interface IProps {
  protocol: IEquipment['protocolId']
}

const DataSourceTag = (props: IProps) => {
  switch (props.protocol) {
    case 'lp-lift':
      return (
        <Tag color="purple">
          {' '}
          <p className="text-caption" style={{ color: 'inherit' }}>
            Станция управления Veda
          </p>
        </Tag>
      )
    case 'lkds':
      return (
        <Tag color="geekblue">
          {' '}
          <p className="text-caption" style={{ color: 'inherit' }}>
            Диспетчерский комплекс "Обь"
          </p>
        </Tag>
      )
    default:
      return null
  }
}

export default DataSourceTag
